import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Footer from '../../components/Footer';
import DonateComponent from '../../components/Donate';
import PageHeader from '../../components/PageHeader';

function DonatePage() {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Optional config
  }, []);
  return (
    <div id="top">
      <PageHeader title={t('donatePage.title')} page={t('donatePage.page')} pageUrl={'donate'} />
      {/* ==== Page Content ==== */}
      <div className="page">
        {/* /container */}
        <DonateComponent />
        {/* /container */}
      </div>
      {/* /page*/}
      <Footer />
    </div>
  );
}

export default DonatePage;
